import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
// import { DateFormatPipe } from "../../../../pipe/dateformat.pipe";
declare var app;

@Component({
  selector: 'app-a2-gift-view',
  templateUrl: './a2-gift-view.component.html',
  styleUrls: ['./a2-gift-view.component.scss']
})
export class A2GiftViewComponent extends GridBaseCase implements AfterViewInit{
  tabsIndex:number = 0;//tabs
  searchValue:string = null;//查询内容
  dataArrayList: Array<any> = [];
  storeArrayList: Array<any> = [];
  storeId:string = null;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName:string = null;
  CustomInterfaceOptions: any = {
    header: '门店',
    // subHeader: 'Select your toppings',
    // message: '$1.00 per topping',
    // translucent: true
  };
  roles:string = null;//角色
  selectText:string = null;//选中的门店名字
  initLoadData:boolean = true;//第一次加载数据
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super(); 
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(this.com.GetAccount.Roles){
      this.com.GetAccount.Roles.forEach(role=>{
        this.roles = role.Code;
      });
    }
  }

  ngAfterViewInit(){
    let that = this;
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
          // that.storeId = item.selectItem || null;
          // that.selectText = item["selectText"] || "";
        }
      })
    }
    this.LoadStoreData();
  }

  /**
   * tabs切换
   * @param n 选择的tabs
   */
  tabsEvent(n){
    this.tabsIndex = n;
    this.LoadGiftData(1);
    // switch(n){
    //   case 0:
    //     this.LoadData(0);
    //     break;
    //   case 1:
    //     this.LoadData(0);
    //     break;
    //   case 2:
    //     this.LoadData(0);
    //     break;
    // }
  }

  /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      this.LoadGiftData(1);
    }
  }
  changeSelect(e){
    let that = this;
    that.storeId = e.target.value || "";
    if(that.storeId){
      that.storeArrayList.forEach((item)=>{
        if(item["a_ID"] == that.storeId){
          that.selectText = item["a_Name"];
        }
      })
    }
    this.LoadGiftData(1);

  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadGiftData(that.PageNumber);
    }
  }
  LoadGiftData(PageNumber){
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // if(that.roles == '1002'){
    //   that.storeId = that.com.GetStorageKey("tbstore")["ID"] || "";
    // }
    if(that.tabsIndex == 0){//待签收
      body.ConfigName = "TBGiftDistribution";
      
      if(that.searchValue){
        body.RequestBody = {"a_FK_TBStore_ID":id,"a_IsSigned":0,"b_Name":that.com.LikeSearch(that.searchValue.trim())};
      }else{
        body.RequestBody = {"a_FK_TBStore_ID":id,"a_IsSigned":0};
      }
      // body.RequestBody = JSON.stringify({"a_FK_TBStore_ID":storeId,"a_IsSigned":false});
    }else if(that.tabsIndex == 1){
      
      if(that.searchValue){
        body.RequestBody = {"a_FK_TBStore_ID":id,"a_IsSigned":1,"b_Name":that.com.LikeSearch(that.searchValue.trim())};
      }else{
        body.RequestBody = {"a_FK_TBStore_ID":id,"a_IsSigned":1};
      }
    }else if(that.tabsIndex == 2){
      body.ConfigName = "TBGiftInventory";
      if(that.searchValue){
        body.RequestBody = {"a_FK_TBStore_ID":id,"a_GiftName":that.com.LikeSearch(that.searchValue.trim())};
      }else{
        body.RequestBody = {"a_FK_TBStore_ID":id};
      }
    }

    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
      // selectItem:that.storeId,
      // selectText:that.selectText || ""
    };
    that.com.SaveSearchInfo(_searchObj);

    body.RequestBody = JSON.stringify(body.RequestBody);
    
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        if(PageNumber != 1){
          that.dataArrayList = that.dataArrayList.concat(data.Status.Datas);
        }else{
          that.dataArrayList = data.Status.Datas;
        }
        that.dataArrayList.forEach(item=>{
          if(item.a_GiftPicture && item.a_GiftPicture.indexOf(app.FileUoloadUrl) == -1){
            item.a_GiftPicture =  (app.FileUoloadUrl + item.a_GiftPicture).replace(app.ImagePlaceholder,app.SmallImageType);
          }
        })
        // data.Status.Datas.forEach(function (item) {
        //   let objfield = {};
        //   that.element.selectItemList.selectItem.forEach((element, index) => {
        //     if (element.bindingField) {
        //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
        //     }
        //   });
        //   that.dataArrayList.push(objfield);
        //   // console.log(that.element.selectItemList.selectItem);
          
        // });
        
        // console.log(that.dataArrayList);
        //   console.log(that.element);
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
 /**
  * 跳转详细页面
  * @param element 
  * @param item 
  */
 EventClick(element,item){
   const that=this;
   console.log(item);
   if(element.url){
    that.com.setHistoryUrl();
    if(this.pageName == 'GiftInventorySignList' && item["isSign"] &&  item["isSign"].value){
      // this.router.navigate(["/tabs/contact/GiftInventorySignForm/view/"+item.id.value + "&" + this.com.getNowDatetime]);
      that.com.Go("/tabs/contact/GiftInventorySignForm/view/"+item.id.value + "&" + this.com.getNowDatetime);
    }else{
      // that.router.navigate([element.url+item.id.value + "&" + that.com.getNowDatetime]);
      that.com.Go(element.url+item.id.value + "&" + that.com.getNowDatetime);
    }
   }
 }

 /**
  * 预览
  * @param 
  */
 imgPreview(imgUrl){
  let that = this;
  let url = [];
  url.push(imgUrl.trim().replace(app.SmallImageType,app.BigImageType));
  let ImgPreview = {
    imgUrl: url,
    index: 0
  }
  // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
  // that.router.navigate(["/tabs/contact/ImgPreview"]);
  that.com.setHistoryUrl();
  that.com.Go("/tabs/contact/ImgPreview",{ ImgPreview: JSON.stringify(ImgPreview)});
  // that.router.navigate(["/tabs/contact/ImgPreview"], {
  //   queryParams: {
  //     ImgPreview: JSON.stringify(ImgPreview)
  //   }
  // });
}

LoadStoreData(){
  let that = this;
  // console.log("1008611");
  // console.log(that.element);
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
 
  body.ConfigName = "TBStoreXML";
  // body.ConfigName="MemberManage";
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = 100;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  that.http.post(app.DEFAULTURL, body).then(data => {
    if (data.ResponseMessage.Success) {
      that.storeArrayList = data.Status.Datas;
      if(!that.storeId && that.storeArrayList.length > 0){
        that.storeId = that.storeArrayList[0]["a_ID"];
        that.selectText = that.storeArrayList[0]["a_Name"];
      }
      that.LoadGiftData(1);
    }
  }).catch(error => {
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
}


LoadData(PageNumber){
  if(!this.initLoadData){
    this.LoadGiftData(PageNumber);
  }else{
    this.initLoadData = false;
  }
}
}
